import React, { CSSProperties } from 'react';
import classnames from 'classnames';

import * as styles from './styles.module.less';

interface INavTitleProps {
  className?: string;
  style?: CSSProperties;
  isWordKeepAll?: boolean;
  children?: any;
}

const NavTitle = ({ children, className, style, isWordKeepAll = false }: INavTitleProps) => {
  return (
    <span
      className={classnames(styles.nav_title, className)}
      style={Object.assign(isWordKeepAll ? { wordBreak: 'keep-all' } : {}, style)}
    >
      {children}
    </span>
  );
};

export default NavTitle;
